import React, { Component } from 'react'
import { Modal, Panel } from 'react-bootstrap'
import { bool, func, object } from 'prop-types'
import { connect } from 'react-redux'
import axios from 'axios'

import {
  updateVideo
} from '../../actions'

import { getAuthToken } from '../../utils/sessionStorage'
import config from '../../config'

class AppropriationTimeModal extends Component {
  constructor () {
    super()

    this.state = {
      appropriationTime: '',
      errors: []
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.saveAppropriationTime = this.saveAppropriationTime.bind(this)
    this.isFormValid = this.isFormValid.bind(this)
  }
  handleInputChange (event) {
    let appropriationTime = event.target.value
    this.setState({
      appropriationTime
    })
  }
  isFormValid () {
    let { appropriationTime } = this.state
    let errors = []
    let videoDuration = this.props.video.duration
    if (appropriationTime <= 0) {
      errors.push('Tempo de apropriação deve ser maior que 0.')
    }
    if (appropriationTime > videoDuration) {
      errors.push('Tempo de apropriação deve ser menor que a duração do video.')
    }
    this.setState({
      errors
    })
    return errors.length === 0
  }
  saveAppropriationTime () {
    let { appropriationTime } = this.state
    let { video, updateVideo } = this.props
    let url = `${config.url}/campaigns/${video.campaign_id}/videos/${video.id}/attribution_time`
    if (this.isFormValid()) {
      axios({
        method: 'post',
        url: url,
        headers: {'X-User-Token': getAuthToken()},
        data: {
          time: appropriationTime
        }
      })
        .then((res) => {
          let updatedVideo = res.data
          updateVideo(video.campaign_id, updatedVideo)
        })
        .catch((err) => {
          console.log('Erro ao salvar tempo de apropriação.')
        })
    }
  }
  render () {
    const { show, close, video } = this.props
    let { appropriationTime, errors } = this.state
    return (
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Tempo de apropriação</Modal.Title>
        </Modal.Header>
        <Modal.Body className='clearfix'>
          {!video.attribution_time &&
            <div>
              <p>Digite o Tempo de Apropriação desse vídeo em segundos:</p>
              <div className='input-control'>
                <input className='form-control' type='text' value={appropriationTime} onChange={this.handleInputChange} />
                <span className='help-block'>Duração do video: {parseInt(video.duration, 10)} segundos.</span>
              </div>
              {errors.length > 0 &&
                <Panel className='mt20' header='Erros ao salvar' bsStyle='danger'>
                  {errors.map((error, index) => (
                    <p key={index}>{error}</p>
                  ))}
                </Panel>
              }
            </div>
          }
          {video.attribution_time &&
            <div>
              Tempo de apropriação: {video.attribution_time} segundos.
            </div>
          }
        </Modal.Body>
        {!video.attribution_time &&
          <Modal.Footer>
            <button className='btn btn-link' onClick={close}>Cancelar</button>
            <button className='btn btn-primary' onClick={this.saveAppropriationTime}>Salvar</button>
          </Modal.Footer>
        }
      </Modal>
    )
  }
}

AppropriationTimeModal.propTypes = {
  show: bool,
  close: func,
  video: object,
  updateVideo: func
}

const mapDispatchToProps = (dispatch) => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video))
  }
})

export default connect(null, mapDispatchToProps)(AppropriationTimeModal)



// WEBPACK FOOTER //
// ./src/components/modals/AppropriationTimeModal.js